import { IdType, Row } from 'react-table';
import { TableRowDataType } from './types';

export const sortRowsBySecondary = <TableRowData extends TableRowDataType>(
  rows: Row<TableRowData>[],
  currentSortById: IdType<TableRowData>,
  sortSecondaryColumnId: IdType<TableRowData>
) =>
  rows.sort(({ original: aOrig }, { original: bOrig }) => {
    if (aOrig[currentSortById] === bOrig[currentSortById]) {
      if (aOrig[sortSecondaryColumnId] === bOrig[sortSecondaryColumnId]) return 0;
      return aOrig[sortSecondaryColumnId] < bOrig[sortSecondaryColumnId] ? -1 : 1;
    }
    return 0;
  });
